<template>
    <page-base :taxpayerInfo="currentTaxpayer">
        <template slot="content">
            <b-alert variant="danger" :show="showAlert">
                {{ alert }}
            </b-alert>
            <b-card class="text-right mb-3" no-body style="padding: 1rem 1.25rem;">
                <a href="javascript:" @click="print"><print-icon title="" />&nbsp;{{ $t('general.print') }}</a>
            </b-card>
            <div id="ticket">
                <b-alert v-if="currentTaxpayer && ticketData" variant="info" show class="text-center">
                    <h5>{{ currentTaxpayer.name }}</h5>
                    <hr>
                    <p>
                        {{ `${$t('general.iinbin')}: ${currentTaxpayer.iin}` }}
                        <br>
                        {{ `${$t('kkm.registration')}: ${ticket.ccmRegistrationNumber || ''}` }}
                        <br>
                        {{ `${$t('kkm.factoryNum')}: ${ticket.ccmFactoryNumber || ''}` }}
                    </p>
                    <p>
                        {{ $t(`ticket.operationTypes.${ticketData.operation_type || 'default'}`) }}
                        <br>
                        {{ `${$t('ticket.onlineTicketNumber')}: ${ticket.onlineTicketnumber || ''}` }}
                        <br>
                        {{ `${$t('ticket.txnClientDate')}: ${$d(ticket.txnClientDate, 'long')}` }}
                        <br>
                        {{ `${$t('ticket.cashierName')}: ${ticket.cashierName || ''}` }}
                    </p>
                </b-alert>
                <b-card>
                    <table class="w-100 mt-3 table table-borderless">
                        <tbody>
                            <tr>
                                <th>{{ $t('ticket.itemName') }}</th>
                                <th>{{ $t('ticket.section') }}</th>
                                <th>{{ $t('ticket.price') }}</th>
                                <th>{{ $t('ticket.quantity') }}</th>
                                <th class="text-right">{{ $t('ticket.total') }}</th>
                            </tr>
                            <tr v-if="hasData" v-for="item in ticketData.items" :key="item.name">
                                <td>{{ item.name }}</td>
                                <td>{{ item.section_code }}</td>
                                <td>{{ item.price }}</td>
                                <td>{{ item.quantity }}</td>
                                <td align="right">{{ item.total }}&nbsp;&#8376;</td>
                            </tr>
                            <tr v-if="hasData" class="border-top">
                                <td colspan="4" class="h4">{{ $t('ticket.totalAmount') }}</td>
                                <td align="right" class="h4">{{ ticketData.total }}&nbsp;&#8376;</td>
                            </tr>
                            <tr v-if="hasData">
                                <td colspan="4">{{ $t('ticket.taken') }}</td>
                                <td align="right">{{ ticketData.payments.cash.taken }}&nbsp;&#8376;</td>
                            </tr>
                            <tr v-if="hasData">
                                <td colspan="4">{{ $t('ticket.change') }}</td>
                                <td align="right">{{ ticketData.payments.cash.change }}&nbsp;&#8376;</td>
                            </tr>
                            <tr class="border-top">
                                <td colspan="5" align="center">{{ `${$t('ticket.onlineTicketNumber')}: ${ticket.onlineTicketNumber || ''}` }}</td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>
            </div>
        </template>
    </page-base>
</template>

<script>
/* eslint-disable */
import AppData from '@/utils/appdata'

export default {
    name: 'TicketDetails',
    mixins: [ AppData ],
    mounted () {
        this.getCurrentTaxpayer()
        this.fetchData()
    },
    data () {
        return {
            ticket: this.$route.params,
            ticketData: {}
        }
    },
    computed: {
        hasData: function () {
            return Object.keys(this.ticketData).length > 0
        }
    },
    methods: {
        fetchData: function () {
            const data = {
                id: this.$route.params.id, 
                dealerId: this.currentTaxpayer 
                    ? this.currentTaxpayer.id 
                    : this.$route.params.dealerId
            };

            const onSuccess = response => {
                if (!Array.isArray(response))
                    throw new Error('Server must be returns array');
                
                if (response.length !== 1){
                    console.error('Get ticket by id must be returns one item');
                    this.$router.push('/error/404');

                    return;
                }

                const ticket = response[0];

                if (ticket.txnClientDate != null)
                    ticket.txnClientDate = new Date(ticket.txnClientDate);
                
                if (ticket.data != null)
                    this.ticketData = JSON.parse(ticket.data);
                
                this.ticket = ticket;
            };

            this.$request.sendRequest(
                this,
                this.$appConfig.apiUrls.ticket.getById,
                data, 
                onSuccess,
                this.displayAlert);
        },
        print: function () {
            this.$htmlToPaper('ticket')
        }
    }
}
</script>
